<style lang='scss' scoped>
.nav-top {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  width: 100%;
  height: 50px;
  box-sizing: border-box;
  background-color: #09659A;
  color: #fff;
  z-index: 250;
  white-space: nowrap;
  & > * {
    position: relative;
    height: inherit;
    display: inline-flex;
    align-items: center;
    box-sizing: border-box;
    padding: 0 6px;
  }

  .nav-logo {
    overflow: hidden;
    width: 208px;
    img {
      width: 127px;
      height: 31px;
    }
  }
  .nav-logo.nav-logo2 {
    width: auto;
    img {
      width: auto;
      height: 33px;
    }
  }
}
</style>


<template>
  <nav class="nav-top clearfix">
    <aside v-if="isSpecialUser"
           class="nav-logo nav-logo2 pull-left">
      <a href="/home">
        <img src="../../../image/logo2.png"
             alt="logo" />
      </a>
    </aside>
    <aside v-else class="nav-logo pull-left">
      <a v-if="hasLogo" href="/home">
        <img :src="logosrcurl" alt="logo" />
      </a>
      <a v-else-if="isUCandPort" href="/home">
        <img src="../../../image/tongyi.png" alt="logo" />
      </a>
       <a v-else-if="isShowQlinYun" href="/home">
        <img src="../../../image/logo_qlinyun_default.png" alt="logo" />
      </a>
      <a v-else href="/home">
        <img src="../../../image/onep.png" alt="logo" />
      </a>
    </aside>
    <comp-navlist style="flex-grow:1;" class="pull-left"></comp-navlist>
    <comp-lang class="pull-right"></comp-lang>
    <comp-userinfo class="pull-right"></comp-userinfo>
    <comp-sys class="pull-right"></comp-sys>
    <comp-notice class="pull-right"></comp-notice>
    <comp-search v-if="showSearch" class="pull-right"></comp-search>
<!--    <comp-guidance class="pull-right"></comp-guidance>-->
  </nav>
</template>

<script>
import { mapState } from 'vuex';
import myHelper from "@mods/utils/helper";
import {
    SOCIAL_HOST_STUB_QLINYUN
} from "@mods/service/base";
import compUserinfo from './userinfo';
import compSys from './sys/index';
import compNavlist from './navlist';
import compLang from './lang';
import compNotice from './notice/index';
import compSearch from './search/index';
//import compGuidance from './guidance/index';
export default {
  components: {
    compUserinfo,
    compSys,
    compLang,
    compNavlist,
    compNotice,
    compSearch,
    //compGuidance
  },
  data () {
    return {
      // logourl:''
      showSearch: true
    }
  },
  computed: {
    ...mapState(['userinfo', 'organization']),
    //自定义logo
    hasLogo () {
       console.log(this.userinfo,'useruseruser');
       console.log(this.organization,'organization');
      return this.organization.logo ? this.organization.logo && /^https?:\/\//.test(this.organization.logo) : this.userinfo.organization.logo && /^https?:\/\//.test(this.userinfo.organization.logo)
    },
    logosrcurl(){
        return this.organization.logo ? this.organization.logo : this.userinfo.organization.logo
    },
    isSpecialUser () {
      // Demon@onepinnovate.com
      //erp 特色用户
      return process.env.VUE_APP_PROJECT_ID == 8 && /^Demon@onepinnovate\.com/gi.test(this.userinfo.email)
    },
    // port系统和uc系统展示不一样的logo
    isUCandPort () {
      return /port.onepinnovate.com|uc-adm.onepinnovate.com/i.test(window.location.href)
    },
    isShowQlinYun () {
        return myHelper.hostStubMatch(window.location.hostname, SOCIAL_HOST_STUB_QLINYUN);
    }
  },
};
</script>
